import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Clientes } from './cliente';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProveedorService {

  

  constructor(private http: HttpClient) { }

 
  getClientes(idEmisor: string) {  
    
    return this.http.get<Clientes[]>(environment.apiUrl+"/listarProveedor/?idEmisor=" + idEmisor);  
  }  

  getCliente(id:string) {  
  
    return this.http.get<Clientes[]>(environment.apiUrl+"/buscarClientePorId/?id="+id);  
  }  

  getClientePorCedula(cedula:string, emisor:string) {  
    console.log(environment.apiUrl+"/buscarClientePorCedula/?cedula="+cedula+"&emisor="+emisor);

    return this.http.get<Clientes[]>(environment.apiUrl+"/buscarClientePorCedula/?cedula="+cedula+"&emisor="+emisor);  
  }  

  setActulizarCliente(clientes: Clientes[]){
    console.log(clientes);
    return this.http.put<string>(environment.apiUrl+"/actulizarProveedor",clientes)
  }

  eliminarCliente(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarCliente/?id="+id);
  }
  



}
